import { useGetObjectTypeTranslations } from "@certa/queries/hooks/dataObjects.hooks";
import { useDataObjectsStore } from "./useDataObjectsStore";
import { useEnableDataObjects } from "../../hooks/useEnableDataObjects";

/**
 * Hook to fetch and manage object types and their translations.
 * - Fetches object types and their translations using React Query
 * - Updates the store with both object types and translations data
 * - Provides access to object types and their translations through store methods
 */
export const useObjectTypeTranslationsManager = () => {
  const isDataObjectsEnabled = useEnableDataObjects();
  const {
    setTranslations,
    getObjectTypeByTag,
    getTranslatedUISchema,
    translationsByObjectType,
    setObjectTypes,
    objectTypes
  } = useDataObjectsStore();

  const { isLoading: isLoadingTranslations } = useGetObjectTypeTranslations({
    config: {
      enabled: isDataObjectsEnabled,
      onSuccess: data => {
        if (data?.length) {
          setTranslations(data);
          setObjectTypes(data);
        }
      }
    }
  });

  return {
    objectTypes,
    isLoadingTypes: isLoadingTranslations,
    getObjectTypeByTag,
    getTranslatedUISchema,
    translationsByObjectType
  };
};
